import { useStarterDashboardV2PageFcm } from 'src/app/pages/starterDashboardV2/pageContext';

type UseTaskReturn = ModelHookResult<{
	showMultiDownloadFlyersTask: boolean;
}>;
export function useTask(): UseTaskReturn {
	const fcms = useStarterDashboardV2PageFcm();
	const showMultiDownloadFlyersTask = fcms.multipleQrCodeFlyersEnabled;

	return {
		data: {
			showMultiDownloadFlyersTask,
		},
	};
}
